<vl-form-message-label :for="name" :class="{'vl-u-visually-hidden': modHiddenLabel}" v-html="parsedLabel"></vl-form-message-label>
<slot :has-errors="hasError"></slot>
<vl-form-message-annotation v-if="annotation" :class="{'vl-form__annotation--no-wrap': modNoWrapAnnotation}" v-html="annotation"></vl-form-message-annotation>
<vl-form-message-error v-if="hasError" :class="{'vl-form__error--no-wrap': modNoWrapError}">
    {{ errors[0] }}
</vl-form-message-error>